import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/reset.css";
import "./styles/index.css";

import { Provider } from "react-redux";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
